var _ = require('underscore');

var angularModule = angular.module('octopusApp.projects');

var ActionUpdater = function () {
    var that = this;

    this.isParameterSensitive = function(parameter){
        return !!parameter.DisplaySettings["Octopus.ControlType"] && parameter.DisplaySettings["Octopus.ControlType"] === "Sensitive";
    };

    this.hasParameterDefaultValue = function(parameter){
        return typeof parameter.DefaultValue !== 'undefined' && parameter.DefaultValue !== null && parameter.DefaultValue !== '';
    };

    this.isPropertySensitive = function(property){
        return Object.prototype.toString.call(property) === "[object Object]";
    };


    this.update = function(action, actionTemplate, defaultPropertyValues){
        var previous = _.clone(action.Properties);
        defaultPropertyValues = defaultPropertyValues || {};

        // In this way we get rid of properties that don't match parameters of the template
        action.Properties = _.clone(actionTemplate.Properties);

        _.each(previous, function(v, k){
            if (_.contains(["Octopus.Action.TargetRoles",
                    "Octopus.Action.MaxParallelism",
                    "Octopus.Action.RunOnServer"], k)){
                action.Properties[k] = v;
            }
        });

        _.each(actionTemplate.Parameters, function(parameter){

            var isParameterSensitive = that.isParameterSensitive(parameter);
            var isPropertySensitive = that.isPropertySensitive(previous[parameter.Name]);

            if (parameter.Name in previous) {
                if (isParameterSensitive === isPropertySensitive) {
                    action.Properties[parameter.Name] = previous[parameter.Name];
                }

                if (isParameterSensitive && !isPropertySensitive) {
                    action.Properties[parameter.Name] = { HasValue: true, NewValue: previous[parameter.Name] };
                }

                // We don't want to expose sensitive information.
                if (!isParameterSensitive && isPropertySensitive) {
                    if (defaultPropertyValues[parameter.Name] !== undefined) {
                        action.Properties[parameter.Name] = defaultPropertyValues[parameter.Name];
                    } else {
                        action.Properties[parameter.Name] = parameter.DefaultValue;
                    }
                }
            }
            else {
                if (defaultPropertyValues[parameter.Name] !== undefined) {
                    action.Properties[parameter.Name] = defaultPropertyValues[parameter.Name];
                }
                 else {
                    if (that.hasParameterDefaultValue(parameter)) {
                        action.Properties[parameter.Name] = parameter.DefaultValue;
                    }
                }
            }
        });

        action.Properties["Octopus.Action.Template.Id"] = actionTemplate.Id;
        action.Properties["Octopus.Action.Template.Version"] = actionTemplate.Version;
    };
};

angularModule.service('actionUpdater', ActionUpdater);

module.exports = ActionUpdater;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/services/action_updater.js
// module id = 569
// module chunks = 1